/**
 * JamDung Logo Component
 * Professional Jamaica-themed logo with customizable sizing and partnership badge support
 */

import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '../../context/ThemeContext';

const JamDungLogo = ({ 
  size = 'medium', 
  showText = true, 
  showPartnershipBadge = false,
  onClick 
}) => {
  const { isDarkMode } = useTheme();
  
  const sizes = {
    small: { logoSize: 24, fontSize: '0.9rem' },
    medium: { logoSize: 32, fontSize: '1.25rem' },
    large: { logoSize: 40, fontSize: '1.5rem' }
  };
  
  // Handle responsive size objects
  const currentSize = typeof size === 'string' ? sizes[size] : sizes.medium;
  
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: 1.5,
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all var(--motion-duration, 0.2s) ease',
        '&:hover': onClick ? { opacity: 0.9 } : {}
      }}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      aria-label="JamDung Jobs - Jamaica's Premier Job Platform"
      className="jamdung-logo"
    >
      {/* Jamaica-Themed Logo Icon */}
      <Box 
        className="jamdung-logo-icon"
        sx={{
          width: typeof size === 'object' ? { xs: 24, sm: 32 } : currentSize.logoSize,
          height: typeof size === 'object' ? { xs: 24, sm: 32 } : currentSize.logoSize,
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #009639 0%, #FFD700 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          fontWeight: 'bold',
          fontSize: typeof size === 'object' ? { xs: '0.6rem', sm: '0.8rem' } : currentSize.logoSize * 0.4,
          boxShadow: '0 2px 8px rgba(0, 150, 57, 0.3)',
          transition: 'transform var(--motion-duration, 0.2s) ease',
          '&:hover': {
            transform: 'scale(1.05)'
          }
        }}
      >
        JD
      </Box>
      
      {/* Platform Name */}
      {showText && (
        <Typography 
          variant="h6"
          className="jamdung-logo-text"
          sx={{ 
            color: isDarkMode ? 'white' : 'var(--color-text-primary)',
            fontWeight: 600,
            fontSize: typeof size === 'object' ? { xs: '0.9rem', sm: '1.25rem' } : currentSize.fontSize,
            background: 'linear-gradient(135deg, #009639 0%, #FFD700 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            display: { xs: size === 'small' ? 'none' : 'block', sm: 'block' },
            transition: 'all var(--motion-duration, 0.2s) ease'
          }}
        >
          JamDung Jobs
        </Typography>
      )}
      
      {/* Partnership Badge - placeholder for future implementation */}
      {showPartnershipBadge && (
        <Box
          sx={{
            ml: 1,
            display: 'flex',
            alignItems: 'center'
          }}
        >
          {/* PartnershipBadge will be imported here once created */}
        </Box>
      )}
    </Box>
  );
};

export default JamDungLogo;